import type { Event } from '@patsnap/tahiti-core';
import type { DocProfileWithMatchedTechFeature, PatentProfileWithMatchedTechFeature, RetrievalResult, TechFeatureSynonym } from '../types';
import type { RETRIEVAL_STRATEGY } from '../constants';
import type { RetrievalElement } from '../apis/retrieval-elements-api';

/**
 * 检索耗时
 */
export interface RetrievalTimeCost {
    /**
     * 检索耗时，单位：秒
     */
    timeSpend: number;
    /**
     * 节省(人工)检索时间，单位：秒
     */
    timeSaved: number;
}

/**
 * 复杂检索服务
 */
export interface ComplexRetrievalService {
    /**
     * 获取检索结果
     * @returns 检索结果
     */
    search(): Promise<RetrievalResult>;
    /**
     * 终止检索
     */
    terminate(): Promise<void>;
    /**
     * 检索开始事件
     * @description 检索开始事件
     */
    onRetrievalStart: Event<void>;
    /**
     * 检索结束事件
     * @description 所有检索结束事件
     */
    onRetrievalComplete: Event<void>;
    /**
     * 专利有匹配特征时的事件
     */
    onPatentFeatureMatched: Event<PatentProfileWithMatchedTechFeature[]>;
    /**
     * 论文有匹配特征时的事件
     */
    onPaperFeatureMatched: Event<DocProfileWithMatchedTechFeature[]>;
    /**
     * 网站有匹配特征时的事件
     */
    onWebsiteFeatureMatched: Event<DocProfileWithMatchedTechFeature[]>;
    /**
     * 技术特征同义词接收事件
     */
    onTechFeatureSynonym: Event<TechFeatureSynonym[]>;
    /**
     * 检索耗时反馈
     * @param time 检索耗时，单位：秒
     */
    onRetrievalTime: Event<RetrievalTimeCost>;
}

export const ComplexRetrievalService = Symbol.for('ComplexRetrievalService');

export interface ComplexRetrievalCallbacks {
    onRetrievalRunning: (name: RETRIEVAL_STRATEGY, running: boolean) => void;
    onRetrievalSuccess: (name: RETRIEVAL_STRATEGY, result: RetrievalResult) => void;
    onPatentFeatureMatched: (patentProfiles: PatentProfileWithMatchedTechFeature[]) => void;
    onPaperFeatureMatched: (paperProfiles: DocProfileWithMatchedTechFeature[]) => void;
    onWebsiteFeatureMatched: (websiteProfiles: DocProfileWithMatchedTechFeature[]) => void;
    onTechFeatureSynonym: (synonyms: TechFeatureSynonym[]) => void;
    /**
     * 检索耗时反馈
     * @param time 检索耗时，单位：秒
     */
    onRetrievalTime: (time: RetrievalTimeCost) => void;
    /**
     * 获取检索要素
     * @param elements 检索要素
     * @param familyMergeEnabled 是否启用同族合并
     */
    onGetSearchElement: (elements: RetrievalElement[],familyMergeEnabled: boolean) => void;
}


export interface ComplexRetrievalRepository {
    search(taskId: string, callbacks: ComplexRetrievalCallbacks): Promise<void>;
    /**
     * 终止当前的检索（循环）
     */
    terminate(): Promise<void>;
}

export const ComplexRetrievalRepository = Symbol.for('ComplexRetrievalRepository');
